import React from "react";
import { IBucketCreateRequest } from "api/entities/bucket";
import { FormFieldError } from "components/shared-ui/form/form-field-error/form-field-error";
import { FormField } from "components/shared-ui/form/form-field/form-field";
import TextInput from "components/shared-ui/input/text-input/text-input";
import styles from "./bucket-name-section.module.scss";

export interface IBucketNameSectionErrors {
  name?: string;
}

export interface IBucketNameSectionProps {
  bucketCreateUpdateRequest: IBucketCreateRequest;
  errors: IBucketNameSectionErrors;
  onChange: (bucketUpdate: Partial<IBucketCreateRequest>) => void;
  onError: (errors: Partial<IBucketNameSectionErrors>) => void;
  className?: string;
  readOnly: boolean;
}

export function BucketNameSection(props: IBucketNameSectionProps) {
  function handleChange(bucketUpdate: Partial<IBucketCreateRequest>) {
    const updatedBucket = {
      ...props.bucketCreateUpdateRequest,
      ...bucketUpdate,
    };
    props.onChange(bucketUpdate);

    props.onError({
      name: updatedBucket.name ? null : "Bucket name is required",
    });
  }

  return (
    <FormField
      testId="bucket-name"
      label="Name"
      className={props.className}
      visible={true}
    >
      <TextInput
        readOnly={props.readOnly}
        className={styles.name}
        testId="bucket-name-input"
        autoFocus={true}
        value={props.bucketCreateUpdateRequest.name}
        onChange={(name) => handleChange({ name })}
      />
      <FormFieldError error={props.errors.name} />
    </FormField>
  );
}
